export default {
    'oh-orange': 'rgba(242, 94, 53, 1)',
}